import { FC, PropsWithChildren, ReactNode, useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isDefined } from '@csp/csp-common-util';
import { PermissionType } from '../../../feature/security/type/PermissionType';
import { PermissionService } from '../../../feature/security/service/PermissionService';
import { CspPath } from '../../../CspPath';
import { getUserSelector } from '../../../feature/security/ducks/principalContextSelectors';

type PermissionCheckComponentProps = PropsWithChildren & {
  permission: PermissionType;
  fallback?: ReactNode;
};

export const PermissionCheckComponent: FC<PermissionCheckComponentProps> = ({
  permission,
  fallback = <Navigate to={CspPath.PAGE_NOT_FOUND} replace />,
  children,
}) => {
  const user = useSelector(getUserSelector);

  const hasPermission = useMemo(
    () => isDefined(user) && PermissionService.hasOrgBranchPermission(permission, user.orgIdsIncludingParents),
    [permission, user],
  );

  if (!hasPermission) {
    return fallback;
  }

  return children;
};
